<div class="mainContainer" [ngClass]="!(preferenceValue.isSwift || preferenceValue.isNCash) ? 'wallet-only-main': ''">
  <span class="Investment-Preferenc" *ngIf="preferenceValue.isSwift || preferenceValue.isNCash">
    Investment
    Preferences
  </span>
  <div class="whiteRectContainer" *ngIf="preferenceValue.isSwift || preferenceValue.isNCash">
    <div class="whiteRectangle">
      <div class="w-50 d-flex justify-content-start">
        <span class="Swift">
          Swift
        </span>
        <app-tooltip placement="bottom"><i class="infoIcon material-icons" trigger>info_outline</i>
          <div class="tooltip-size" content><span class="black-text">Swift</span> is a convenient investment option allowing you to automatically invest your wallet funds into the loan(s) without any intervention from your end.</div>
        </app-tooltip>
      </div>
      <div class="w-50 d-flex justify-content-end">
        <a class="View" (click)="onViewPopup('view-swift')" [ngClass]="{'disable': !preferenceValue.isSwift}">
          View
        </a>
      </div>
    </div>
    <div class="whiteRectangle">
      <div class="w-50 d-flex justify-content-start">
        <span class="Swift">
          nCash
        </span>
        <app-tooltip placement="bottom"><i class="infoIcon material-icons" trigger>info_outline</i>
          <div class="tooltip-size" content><span class="black-text">nCash</span> provides you an option to withdraw a fixed or a customized amount periodically from your <span class="black-text">finzyFLEX</span> investments.</div>
        </app-tooltip>
      </div>
      <div class="w-50 d-flex justify-content-end">
        <a class="View" (click)="onViewPopup('nCash')" [ngClass]="{'disable': !preferenceValue.isNCash}">
          View
        </a>
      </div>
    </div>
  </div>
  <div class="wallet-box" [ngClass]="!(preferenceValue.isSwift || preferenceValue.isNCash) ? 'wallet-only-box': ''" *ngIf="preferenceValue.walletAmount > 0">
    <div class="w-100 d-flex justify-content-center">
      <span class="wallet">
        Wallet Amount
      </span>
    </div>
    <div class="w-100 d-flex justify-content-center">
      <span class="amount">
        <span class="rupee-symbol"> ₹ </span> {{preferenceValue.walletAmount | currency:'INR': '' }}
      </span>
    </div>
  </div>
</div>
<div class="info-section">
  <span class="info-text" *ngIf="(preferenceValue.isSwift || preferenceValue.isNCash)">Above are your selected investment preferences, you can always choose to <strong>modify</strong> your preferences from the <strong>Dashboard</strong> after your account verification.</span>
  <span class="info-text" *ngIf="!(preferenceValue.isSwift || preferenceValue.isNCash)">In the meanwhile to know more about our product <a class="blue-text" target="_blank" href="/faq?selectedTab=FINZY_FLEX">click here.</a></span>
</div>